import Vue from "vue";
import Vuetify from "vuetify/lib";
import "material-design-icons-iconfont/dist/material-design-icons.css";
Vue.use(Vuetify);

export default (ctx) => {
  const vuetify = new Vuetify({
    theme: {
      dark: false,
      themes: {
        light: {
          primary: "#FF6B28",
          success: "#47C54F"
        }
      }
    },
    icons: {
      iconfont: "mdi",
      values: {
        testIcon: {
          component: require("~/assets/icons/testIcon.svg?inline")
        },
        menuBookIcon: {
          component: require("~/assets/icons/menuBookIcon.svg?inline")
        },
        muteIcon: {
          component: require("~/assets/icons/muteIcon.svg?inline")
        },
        computerIcon: {
          component: require("~/assets/icons/computer.svg?inline")
        },
        cartMenuIcon: {
          component: require("~/assets/icons/cartMenuIcon.svg?inline")
        },
        createRestaurantIcon: {
          component: require("~/assets/icons/createRestaurantIcon.svg?inline")
        },
        hambergerIcon: {
          component: require("~/assets/icons/hambergerIcon.svg?inline")
        },
        externalLinkIcon: {
          component: require("~/assets/icons/externalLinkIcon.svg?inline")
        },
        imageIcon: {
          component: require("~/assets/icons/imageIcon.svg?inline")
        },

        locationIcon: {
          component: require("~/assets/icons/locationIcon.svg?inline")
        },
        menuArrowsIcon: {
          component: require("~/assets/icons/menuArrows.svg?inline")
        },
        mobileIcon: {
          component: require("~/assets/icons/mobile.svg?inline")
        },
        personIcon: {
          component: require("~/assets/icons/person.svg?inline")
        },
        refreshIcon: {
          component: require("~/assets/icons/refreshIcon.svg?inline")
        },
        reportIcon: {
          component: require("~/assets/icons/reportIcon.svg?inline")
        },
        setLocationIcon: {
          component: require("~/assets/icons/setLocation.svg?inline")
        },
        tabIcon: {
          component: require("~/assets/icons/tab.svg?inline")
        },
        invoiceIcon: {
          component: require("~/assets/icons/invoiceIcon.svg?inline")
        },
        modifyIcon: {
          component: require("~/assets/icons/modifyIcon.svg?inline")
        },
        downloadIcon: {
          component: require("~/assets/icons/downloadIcon.svg?inline")
        },
        editIcon: {
          component: require("~/assets/icons/editIcon.svg?inline")
        },
        printerIcon: {
          component: require("~/assets/icons/printerIcon.svg?inline")
        },
        deleteIcon: {
          component: require("~/assets/icons/deleteIcon.svg?inline")
        },
        menuMobileIcon: {
          component: require("~/assets/icons/menuMobileIcon.svg?inline")
        },
        receiverMobileIcon: {
          component: require("~/assets/icons/receiverMobileIcon.svg?inline")
        },
        reportsBarIcon: {
          component: require("~/assets/icons/reportsBarIcon.svg?inline")
        },
        settingsIcon: {
          component: require("~/assets/icons/settingsIcon.svg?inline")
        },
        mapIcon: {
          component: require("~/assets/icons/mapIcon.svg?inline")
        },
        rightArrowIcon: {
          component: require("~/assets/icons/rightArrowIcon.svg?inline")
        },
        leftArrowIcon: {
          component: require("~/assets/icons/leftArrowIcon.svg?inline")
        },
        communicationIcon: {
          component: require("~/assets/icons/communicationIcon.svg?inline")
        },
        bagIcon: {
          component: require("~/assets/icons/bagIcon.svg?inline")
        },
        refreshIcon2: {
          component: require("~/assets/icons/refreshIcon2.svg?inline")
        },
        coinIcon: {
          component: require("~/assets/images/insights/revenue-per-hour.svg?inline")
        },
        searchIcon: {
          component: require("~/assets/icons/searchIcon.svg?inline")
        },
        customiseIcon: {
          component: require("~/assets/icons/customiseIcon.svg?inline")
        }
      }
    }
  });

  ctx.app.vuetify = vuetify;
  ctx.$vuetify = vuetify.framework;
};
